export default __webpack_public_path__ + "static/media/group.6032632f.svg";